import { useCallback, useMemo } from 'react'

import { MultiSelect } from 'govwell-ui'
import { SelectOption } from 'govwell-ui/components/Select/types'

type Props = {
  caption?: React.ReactNode
  errorMessage?: string
  isClearable?: boolean
  isInvalid?: boolean
  isRequired?: boolean
  label?: React.ReactNode
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void
  onValueChange: (value: string[]) => void
  placeholder?: string
  value: string[]
  width?: React.CSSProperties['width']
}
const CreatableStringSelect = ({
  caption,
  errorMessage,
  isClearable,
  isInvalid,
  isRequired,
  label,
  onBlur,
  onValueChange,
  placeholder,
  value,
  width,
}: Props) => {
  const handleSelectedOptionsChange = useCallback(
    (newSelectedOptions: SelectOption<string>[] | undefined) => {
      onValueChange(newSelectedOptions?.map((o) => o.value) ?? [])
    },
    [onValueChange]
  )

  const selectedOptions = useMemo(() => value.map((v) => ({ label: v, value: v })), [value])
  const handleCreateOption = useCallback(
    (searchQuery: string) => {
      handleSelectedOptionsChange([...selectedOptions, { label: searchQuery, value: searchQuery }])
    },
    [handleSelectedOptionsChange, selectedOptions]
  )

  const getOptionKey = useCallback((option: SelectOption<string>) => option.value, [])

  return (
    <MultiSelect
      {...(label ? { label } : { ariaLabel: 'String' })}
      caption={caption}
      errorMessage={errorMessage}
      getOptionKey={getOptionKey}
      isClearable={isClearable}
      isCreatable
      isInvalid={isInvalid}
      isRequired={isRequired}
      onBlur={onBlur}
      onCreateOption={handleCreateOption}
      options={selectedOptions}
      onSelectedOptionsChange={handleSelectedOptionsChange}
      placeholder={placeholder}
      selectedOptions={selectedOptions}
      width={width}
    />
  )
}

export default React.memo(CreatableStringSelect)
